const IconMail: React.FC = props => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M2 4H22V20H2V4Z" stroke="currentColor" strokeWidth="2" />
        <path d="M2 7L12 13L22 7" stroke="currentColor" strokeWidth="2" />
    </svg>
);

export default IconMail;
